import React, { useEffect, useState } from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid, Card, CardContent, Typography, makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BPicon from '../../../../../src/img/dashboard_icons/BPicon.svg';
import Stepsicon from '../../../../../src/img/dashboard_icons/footstepsicon.svg'
import Stairs from '../../../../../src/img/steps-icon.svg';
import BloodGlucose from '../../../../../src/img/dashboard_icons/Blood-Glucose.svg';
import CaloriesBurnt from '../../../../../src/img/dashboard_icons/CaloriesBurnt.svg'
import OxygenIcon from '../../../../../src/img/oxygen-icon.svg';
import BloodPressure from '../../../../../src/img/Group 14412.svg'
import WeightIcon from '../../../../../src/img/weight-icon.png';
import HeightIcon from '../../../../../src/img/height-icon.svg'
import SleepIcon from '../../../../../src/img/sleep-icon.svg';
import StandIcon from '../../../../../src/img/stand-icon.svg';
import CycleIcon from '../../../../../src/img/cycle-icon.svg';
import ExcerciseIcon from '../../../../../src/img/excercise-icon.svg';
import RestingIcon from '../../../../../src/img/resting-icon.svg';
import SwimmingIcon from '../../../../../src/img/swiming-icon.svg';
import BodyTempIcon from '../../../../../src/img/body-temp-icon.svg';
import HeartIcon from '../../../../../src/img/heart-icon.svg';
import WalkAndRunIcon from '../../../../../src/img/walk-run-icon.svg';
import BodyMassIndexIcon from '../../../../../src/img/body-mass-index.svg';


const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 12,
    border: '2px solid #E0E0E0',
    height: '100%',
    backgroundColor: '#fff',
    paddingTop: '0px',
    cursor: 'pointer'
  },
  divider: {
    width: '2px',
    height: '60px',
    borderRadius: '4px',
  },
  metric: {
    fontWeight: 'bold',
    fontSize: '1.1rem',
  },
  label: {
    fontSize: '1rem',
    color: '#666666',
    fontWeight: 600,
  },
  time: {
    fontSize: '0.75rem',
    color: '#888',
  },
}));
const typeLabelMap = {
  BloodPressureCombined: "Blood Pressure",
  BloodPressureCount: "Blood Pressure",
  BloodGlucoseCount: "Blood Glucose",
  HeartCount: "Heart rate",
  SleepCount: "Sleep",
  Weight: "Weight",
  Height: "Height",
  PeakFlow: "Peak flow",
  Bodytemperature: "Temperature",
  StepsCount: "Steps",
  OxegenCount: "Blood oxygen",
  ExerciseMinutes: "Exercise minutes",
  RunningWalking: "Distance (walking+Running)",
  CaloriesCount: "Calories burnt",
  RestingHR: "Resting HR",
  BreathingRate: "Breathing rate /Respiratory rate",
  BodyMass: "Body mass index",
  Floors: "Stairs climbed",
  CyclingDistance: "Cycling Distance",
  SwimmingDistance: "Swimming Distance",
  StandHours: "Stand Hours",
  ExerciseDistance: "Exercise Distance",
  BodyMassIndex: "Body Mass Index",
};
const typeIconMap = {
  BloodPressureCombined: BloodPressure,
  BloodPressureCount: BloodPressure,
  BloodGulcoseCount: BloodGlucose,
  HeartCount: HeartIcon,
  SleepCount: SleepIcon,
  Weight: WeightIcon,
  Height: HeightIcon,
  Bodytemperature: BodyTempIcon,
  StepsCount: Stepsicon,
  OxegenCount: OxygenIcon,
  ExerciseMinutes: ExcerciseIcon,
  RunningWalking: WalkAndRunIcon,
  CaloriesCount: CaloriesBurnt,
  RestingHR: RestingIcon,
  BreathingRate: RestingIcon,
  BodyMass: WeightIcon,
  Floors: Stairs,
  Floor: Stairs,
  CyclingDistance: CycleIcon,
  SwimmingDistance: SwimmingIcon,
  StandHours: StandIcon,
  ExerciseDistance: ExcerciseIcon,
  BodyMassIndex: BodyMassIndexIcon,
  PeakFlow: StandIcon,

};
function DailyActivities(props) {
  const patientId = localStorage.getItem('loginUserId')
  const [healthkitData, setHealthkitData] = useState([]);
  const [filter, setFilter] = useState([]);
  let [progress, setProgress] = useState(false);
  useEffect(() => {
    setProgress(true);
    const url = `${process.env.REACT_APP_BASEURL}healthkit?id=${patientId}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(res => res.json())
      .then(res => {
        setProgress(false);

        if (res.data && Array.isArray(res.data)) {
          console.log(res.data)
          const flattened = res.data.flatMap(entry => entry.data);
          setFilter(flattened);
          const sorted = res.data.sort(
            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
          );

          // Use a Map to track first non-zero value for each type
          const typeMap = new Map();

          for (const snapshot of sorted) {
            for (const entry of snapshot?.data) {
              if (entry.value !== 0 && !typeMap.has(entry.type)) {
                typeMap.set(entry.type, entry);
              }
            }
          }

          // Convert map values to array
          const finalHealthkitData = Array.from(typeMap.values());
          setHealthkitData(finalHealthkitData);
        } else {
          console.log("erron on fetching health kit data");
          setHealthkitData([]);
        }
      })
      .catch(error => {
        setProgress(false);
        console.error("Fetch error:", error);
      });
  }, []);


  const getTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;

    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffWeeks = Math.floor(diffDays / 7);
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    if (diffMins < 60) return `${diffMins} min${diffMins !== 1 ? "s" : ""} ago`;
    if (diffHours < 24) return `${diffHours} hr${diffHours !== 1 ? "s" : ""} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
    if (diffWeeks < 4) return `${diffWeeks} week${diffWeeks !== 1 ? "s" : ""} ago`;
    if (diffMonths < 12) return `${diffMonths} month${diffMonths !== 1 ? "s" : ""} ago`;
    return `${diffYears} year${diffYears !== 1 ? "s" : ""} ago`;
  };

  const processedData = [];

  const bpSysDiaPairs = healthkitData
    .filter(item =>
      item.type === 'BloodPressureSysCount' || item.type === 'BloodPressureDiaCount'
    )
    .reduce((acc, item) => {
      const key = item.startDate;
      if (!acc[key]) acc[key] = {};
      if (item.type === 'BloodPressureSysCount') {
        acc[key].sys = item.value;
      } else if (item.type === 'BloodPressureDiaCount') {
        acc[key].dia = item.value;
      }
      acc[key].unit = item.unit;
      acc[key].endDate = item.endDate;
      acc[key].type = item.type;
      return acc;
    }, {});

  Object.entries(bpSysDiaPairs).forEach(([_, bp]) => {
    if (bp.sys && bp.dia) {
      processedData.push({
        label: typeLabelMap["BloodPressureCombined"],
        value: `${bp.sys}/${bp.dia}`,
        unit: bp.unit,
        type: bp.type,
        timeAgo: getTimeAgo(bp.endDate),
        icon: typeIconMap["BloodPressureCombined"]
      });
    }
  });


  healthkitData
    .filter(item =>
      item.type !== 'BloodPressureSysCount' && item.type !== 'BloodPressureDiaCount'
    )
    .forEach(item => {
      let value = parseFloat(Number(item.value).toFixed(2));
      let unit = item.unit;




      if (item.type === 'SleepCount') {
        value = parseFloat((item.value / 3600).toFixed(2));
        unit = value < 1 ? 'Hr' : 'Hrs';

      }

      processedData.push({
        label: typeLabelMap[item.type] || item.type,
        value,
        unit,
        type: item.type,
        timeAgo: getTimeAgo(item.endDate),
        icon: typeIconMap[item.type] || null
      });
    });

  const classes = useStyles();
  const goBack = (event) => {
    event.preventDefault();
    props.history.goBack()
  }

  const handleActivity = (type) => {
    let filteredByType;
    if (type === "BloodPressureDiaCount") {
      filteredByType = filter.filter(item =>
        (item.type === "BloodPressureSysCount" || item.type === "BloodPressureDiaCount") &&
        item.value !== 0
      )


        ;
    } else {
      filteredByType = filter.filter(item => item.type === type && item.value !== 0);
    }

    const formattedData = filteredByType.map(item => ({
      ...item,
      value: parseFloat(item.value.toFixed(2))

    }))



    props.history.push({
      pathname: '/patient/metricsGraph',
      state: { filteredData: formattedData }
    });
  };


  return (
    <>
      {progress && <div className="fullScreen">
        <CircularProgress
          disableShrink
          className="progressCircle"
          value={90}
          size={100}
          thickness={1.5}
        />
      </div>}
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '10px' }}>

        <h1 className="mr-auto primary-header">Daily Activities</h1>

        <button className="btn btn-primary-blue btn-rounded btn-small" style={{ float: "right" }} onClick={goBack}>
          Back
        </button>
      </div>
      <Grid container spacing={2}>

        {processedData.map((activity, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card className={classes.card} elevation={0} onClick={() => handleActivity(activity.type)}>
              <CardContent style={{ width: '100%', padding: '10px' }}>
                <Typography className={classes.label} style={{ marginBottom: 4 }}>
                  {activity.label}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ fontSize: '2rem', color: activity.color, marginRight: 8 }}>
                    <img
                      src={activity.icon}
                      alt={""}
                      style={{ width: 40, height: 40, marginRight: 8 }}
                    />
                  </div>

                  <div
                    className={classes.divider}
                    style={{ backgroundColor: "#999999" }}
                  />

                  <div style={{ marginLeft: 12 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                      <Typography className={classes.metric}>{activity.value}</Typography>
                      <Typography >{activity.unit}</Typography>
                    </div>


                    {activity.timeAgo && (
                      <Typography className={classes.timtimeAgoe}>{activity.timeAgo}</Typography>
                    )}

                  </div>
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>


    </>
  )

}
const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    langData: state.langData,
    lang: state.lang,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(DailyActivities));






